import { AppLocale } from '@/shared/i18n';
import { TrialPaywallTranslationKey } from '@/shared/i18n/translations/trialPaywall';

const getPluralSuffix = (locale: AppLocale, count: number) => {
  switch (new Intl.PluralRules(locale).select(count)) {
    case 'one':
      return 'One';
    case 'few':
      return 'Few';
    case 'many':
      return 'Many';
    default:
      return 'Other';
  }
};

export const getTrialPaywallMinutesKey = (locale: AppLocale, count: number): TrialPaywallTranslationKey =>
  `trialPaywall.card.minutes${getPluralSuffix(locale, count)}`;

export const getTrialPaywallBenefitMinutesKey = (
  locale: AppLocale,
  count: number,
  isYearly: boolean,
): TrialPaywallTranslationKey =>
  `trialPaywall.benefits.${isYearly ? 'yearly' : 'monthly'}Minutes${getPluralSuffix(locale, count)}`;
